import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=90ad1832&"
import script from "./ReportForm.vue?vue&type=script&lang=ts&"
export * from "./ReportForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportForm.vue?vue&type=style&index=0&id=90ad1832&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports